export default "__VITE_ASSET__ByIfrvt5__"